import { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import { userSimpleAtom } from "recoil/userSimpleAtom";
import {
  axiosInstancePromotion,
  CustomResponseFormat,
  setBearerTokenPromotion,
} from "api/instancePromotion";
import { userApi } from "api/userApi";

export default function useAutoLoginPromotion() {
  const [isChecking, setIsChecking] = useState(true);
  const [user, setUser] = useRecoilState(userSimpleAtom);

  useEffect(() => {
    // 이미 로그인되어 있으면 체크 안함
    if (user?.accessToken) {
      setIsChecking(false);
      return;
    }

    // refreshToken(쿠키)으로 자동 로그인 시도
    const autoLogin = async () => {
      try {
        const response = await axiosInstancePromotion.get<CustomResponseFormat>(
          "/user/v2/token/refresh"
        );

        if (response.code === 0 && response.result?.accessToken) {
          const newAccessToken = response.result.accessToken;

          // axios 헤더 설정 (instancePromotion용)
          setBearerTokenPromotion(newAccessToken);

          try {
            // user 전체 정보 가져오기
            const userResponse = await userApi.getSimplePromotion();

            if (userResponse.code === 0 && userResponse.result) {
              // 전체 user 정보를 recoil atom에 설정
              setUser({
                accessToken: newAccessToken,
                ...userResponse.result,
              });
            } else {
              // user 정보 가져오기 실패 시 accessToken만 설정
              setUser({ accessToken: newAccessToken });
            }
          } catch (userError) {
            console.log("Failed to fetch user info:", userError);
            // user 정보 가져오기 실패해도 accessToken은 설정
            setUser({ accessToken: newAccessToken });
          }
        }
      } catch (error) {
        console.log("Auto login failed - no valid refresh token");
      } finally {
        setIsChecking(false);
      }
    };

    autoLogin();
  }, [setUser]);

  return { isChecking };
}
